import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { Observable } from 'rxjs';
import { Business } from 'ng2-app/models/businesses/Business.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BusinessesService {
  constructor(
    private http: ApiHttpClient
  ) { }

  addBusinessesToQueue(borrowerIds: number[]): Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/business-management/businesses/queue`, { borrowerIds });
  }

  get(): Observable<Business[]> {
    return this.http.get<Business[]>(`${environment.API_URL}/business-management/businesses`);
  }

  getBusiness(id: number): Observable<Business> {
    return this.http.get<Business>(`${environment.API_URL}/business-management/business/${id}`);
  }

  snooze(borrowerIds: number[]): Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/business-management/businesses/clear`, { borrowerIds });
  }
}
